import { DateTime } from 'luxon'

import type { RightOfAccess } from '../../api/apiHooks/useAPIGetRightsOfAccess'
import type { SharedArea } from '../../api/apiHooks/useAPIGetSharedAreas'

export const getActiveGymRights = (
  rightsOfAccess: RightOfAccess[] | undefined
) => {
  const today = DateTime.now().startOf('day')

  return (
    rightsOfAccess?.filter((ra) => {
      if (ra.type !== 'gym') return false
      const endDate = ra.endDate
        ? DateTime.fromISO(ra.endDate).endOf('day')
        : null
      return !endDate || endDate >= today
    }) ?? []
  )
}

export const getPriceForDate = (gymArea: SharedArea, date: string) => {
  return gymArea.monthlyPrices.find(
    (price) => price.validFrom <= date && price.validTo >= date
  )
}
